import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { RequireAuth, CHANGE_PASSWORD_PATH } from '@/features/auth/RequireAuth';
import { RequirePermission, RequireSuperAdmin } from '@/features/auth/RequirePermission';
import { LoginPage } from '@/features/auth/LoginPage';
import { ChangePasswordPage } from '@/features/auth/ChangePasswordPage';
import { AccountPage } from '@/features/account/AccountPage';
import { UsersPage } from '@/features/users/UsersPage';
import { RolesPage } from '@/features/roles/RolesPage';
import { AuditPage } from '@/features/audit/AuditPage';
import { DevToolsPage } from '@/features/devtools/DevToolsPage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { LeadsPage } from '@/features/leads/LeadsPage';
import { LeadDetailPage } from '@/features/leads/LeadDetailPage';
import { CampaignsPage } from '@/features/campaigns/CampaignsPage';
import { CampaignDetailPage } from '@/features/campaigns/CampaignDetailPage';
import { CallsPage } from '@/features/calls/CallsPage';
import { CallDetailPage } from '@/features/calls/CallDetailPage';
import { EmailsPage } from '@/features/emails/EmailsPage';
import { ScriptsPage } from '@/features/scripts/ScriptsPage';
import { ProductsPage } from '@/features/products/ProductsPage';
import { BrandsPage } from '@/features/brands/BrandsPage';
import { SettingsPage } from '@/features/settings/SettingsPage';
import { NotFoundPage } from '@/app/NotFoundPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: CHANGE_PASSWORD_PATH,
    element: (
      <RequireAuth>
        <ChangePasswordPage />
      </RequireAuth>
    ),
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'leads', element: <LeadsPage /> },
      { path: 'leads/:id', element: <LeadDetailPage /> },
      { path: 'campanhas', element: <CampaignsPage /> },
      { path: 'campanhas/:id', element: <CampaignDetailPage /> },
      { path: 'chamadas', element: <CallsPage /> },
      { path: 'chamadas/:id', element: <CallDetailPage /> },
      { path: 'emails', element: <EmailsPage /> },
      { path: 'scripts', element: <ScriptsPage /> },
      { path: 'produtos', element: <ProductsPage /> },
      { path: 'marcas', element: <BrandsPage /> },
      { path: 'configuracoes', element: <SettingsPage /> },
      { path: 'minha-conta', element: <AccountPage /> },
      {
        path: 'usuarios',
        element: (
          <RequirePermission permission="users.read">
            <UsersPage />
          </RequirePermission>
        ),
      },
      {
        path: 'perfis',
        element: (
          <RequirePermission permission="roles.read">
            <RolesPage />
          </RequirePermission>
        ),
      },
      {
        path: 'auditoria',
        element: (
          <RequirePermission permission="audit.read">
            <AuditPage />
          </RequirePermission>
        ),
      },
      {
        path: 'ferramentas',
        element: (
          <RequireSuperAdmin>
            <DevToolsPage />
          </RequireSuperAdmin>
        ),
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
